import { TypedDocumentNode } from '@apollo/client';
import gql from 'graphql-tag.macro';

import useMutation from '@sorare/core/src/hooks/graphql/useMutation';

import { RewardBoxDialogWithOnboarding } from '@sorare/gameplay/src/components/rewards/RewardBoxDialogWithOnboarding';

import {
  ClaimMissionTaskMutation,
  ClaimMissionTaskMutationVariables,
} from './__generated__/useClaimMissionTask.graphql';

const CLAIM_MISSION_TASK_MUTATION = gql`
  mutation ClaimMissionTaskMutation($name: ManagerProgressionTaskSlug!) {
    claimManagerProgressionTask(input: { name: $name, sport: FOOTBALL }) {
      managerProgressionTaskOrMission {
        id
        ... on ManagerProgressionMission {
          id
          aasmState
          probabilisticBundles {
            id
            ...RewardBoxDialogWithOnboarding_probabilisticBundle
          }
        }
      }
      errors {
        message
        code
      }
    }
  }
  ${RewardBoxDialogWithOnboarding.fragments.probabilisticBundle}
` as TypedDocumentNode<
  ClaimMissionTaskMutation,
  ClaimMissionTaskMutationVariables
>;

export const useClaimMissionTask = () => {
  return useMutation(CLAIM_MISSION_TASK_MUTATION);
};
